import React from 'react';
import { motion } from 'framer-motion';

const IncidentStats = ({ incidents }) => {
  const stats = {
    total: incidents.length,
    pending: incidents.filter(i => i.status === 'pendiente').length,
    inProgress: incidents.filter(i => i.status === 'en_proceso').length,
    resolved: incidents.filter(i => i.status === 'resuelto').length
  };

  const statItems = [
    {
      label: 'Total',
      value: stats.total,
      bgColor: 'bg-gray-100',
      textColor: 'text-gray-700',
      borderColor: 'border-gray-200'
    },
    {
      label: 'Pendientes',
      value: stats.pending,
      bgColor: 'bg-amber-50',
      textColor: 'text-amber-700',
      borderColor: 'border-amber-200'
    },
    {
      label: 'En Proceso',
      value: stats.inProgress,
      bgColor: 'bg-blue-50',
      textColor: 'text-blue-700',
      borderColor: 'border-blue-200'
    },
    {
      label: 'Resueltos',
      value: stats.resolved,
      bgColor: 'bg-green-50',
      textColor: 'text-green-700',
      borderColor: 'border-green-200'
    }
  ];

  return (
    <div className="grid grid-cols-2 gap-2">
      {statItems.map((item, index) => (
        <motion.div
          key={item.label}
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: index * 0.1 }}
          className={`${item.bgColor} ${item.borderColor} border rounded-lg px-3 py-2 flex flex-col items-center justify-center`}
        >
          <span className={`text-lg font-bold ${item.textColor}`}>{item.value}</span>
          <span className={`text-xs font-medium ${item.textColor}`}>{item.label}</span>
        </motion.div>
      ))}
    </div>
  );
};

export default IncidentStats;